import React, { useContext, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import leave from "../../../assets/img/leave.svg"
import { removeUserCommunities } from "../../../services/apiProfile";
import { CommunityContext } from "../../../config/CommunityContext";
const LeaveCommunity = ({ isLeaveCommunity, handleClose, community, getCommunity, root }) => {
  const Group = require("../../../assets/img/Featured icon.jpg");
const { fetchAllCommunities } = useContext(CommunityContext);
const user = JSON.parse(localStorage.getItem('userData')); 
  const removeCommunities = async () => {       
    let formData ={}
          if(root === "edit"){
             formData = {
              communityid: community.community[0]?._id,
              userid: user._id
          }           
          }
          else{
             formData = {
              communityid: community.communities?._id,
              userid: user._id
          } 
          }
           let removCommunities = await removeUserCommunities(formData);

          getCommunity();
          if(removCommunities.status)
          {
            await fetchAllCommunities({ userid: user._id });
            handleClose()
          }
      };
  return (

    <div >
      <Modal show={isLeaveCommunity} onHide={handleClose} 
      dialogClassName="small-custom-modal modal-dialog-centered">
        <Modal.Header closeButton>
        <div className="popupheader">
        <div className="mod-bor-icon" >
              <img src={leave} className="mod-icon"></img>
            </div>
            <div className="header">
              <div className="signuup">Leave Community</div>
              <p className="Stronger">{community?.communities?.communityName}</p>

            </div>
          </div>
        </Modal.Header>
        <Modal.Body>

          <div>
            <p className="fov-text">Do you want to leave the Community</p>
          </div>


        </Modal.Body>
    <Modal.Footer className="full-w" >
                 <button type="button" className="cancel-btn"  onClick={() => handleClose()}>No</button>
                  <button className="next-btn" onClick={() => removeCommunities()} >Yes</button>
        </Modal.Footer>

      </Modal>
    </div>
  );

};
export default LeaveCommunity;
